/*
  youtube埋め込み再生iOS自動再生対応版

  # pug
  .youtube-player(data-id="YOUTUBE_VIDEO_ID", autoplay, loop)

  自動再生等しない時はattributeを削る
  .youtube-player(data-id="YOUTUBE_VIDEO_ID")

  # CSS
  .youtube-player {
    width: 640px;
    iframe {
      width:100%;
      height:auto;
      aspect-ratio: 16 / 9;
    }
  }
*/

export default class YoutubeEmbedPlayer {
  static PLAYER_COUNT = 0;

  constructor() {
    this.setScript();
  }

  setScript() {
    // If the API is already loaded (e.g. cached / injected by other libs), initialize immediately.
    if (window.YT && window.YT.Player) {
      this.createPlayer();
      return;
    }

    if (!window.YT) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName("script")[0];
      if (firstScriptTag && firstScriptTag.parentNode)
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = () => {
        this.createPlayer();
      };
    }
  }

  createPlayer() {
    const youtubeElements = Array.prototype.slice.call(
      document.getElementsByClassName("youtube-player")
    );
    for (const elem of youtubeElements) {
      new YoutubeElem(elem);
    }
  }
}

class YoutubeElem {
  constructor(node) {
    this.node = node;
    this.thumb = this.node.firstElementChild;
    this.playerNode = document.createElement("div");
    this.isAutoPlay = this.node.getAttribute("autoplay") !== null;
    this.isLoop = this.node.getAttribute("loop") !== null;
    this.createPlayer();
  }

  createPlayer() {
    if (!this.node || !this.node.dataset.id) return;

    this.node.appendChild(this.playerNode);
    // console.log(this.isAutoPlay);
    // console.log(this.node);

    this.ytPlayer = new window.YT.Player(this.playerNode, {
      videoId: this.node.dataset.id,
      playerVars: {
        controls: 0,
        autoplay: this.isAutoPlay ? 1 : 0,
        loop: this.isLoop ? 1 : 0,
        // YouTube requires playlist=<videoId> for single-video looping.
        ...(this.isLoop ? { playlist: this.node.dataset.id } : {}),
        disablekb: 1,
        enablejsapi: 1,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0,
        showinfo: 0,
        autohide: 1
      },
      events: {
        onReady: this.onPlayerReady.bind(this),
        onStateChange: this.onPlayerStateChange.bind(this)
      }
    });
    if (this.thumb) {
      this.thumb.addEventListener("click", () => {
        this.ytPlayer.playVideo();
        this.thumb.classList.add("hide");
      });
    }
  }

  onPlayerReady(event) {
    if (!this.isAutoPlay) return;
    event.target.mute();
    event.target.playVideo();
    if (this.thumb) this.thumb.classList.add("hide");
  }

  onPlayerStateChange(event) {
    const ytStatus = event.target.getPlayerState();
    if (this.thumb) {
      if (ytStatus === window.YT.PlayerState.PAUSED || ytStatus === window.YT.PlayerState.ENDED) {
        this.thumb.classList.remove("hide");
      }
      if (ytStatus === window.YT.PlayerState.PLAYING) {
        this.thumb.classList.add("hide");
      }
    }
    if (ytStatus === window.YT.PlayerState.ENDED) {
      if (!this.isLoop) return;
      this.ytPlayer.mute();
      this.ytPlayer.playVideo();
    }
  }
}
